import { PublicClientApplication } from "@azure/msal-browser";
import * as Msal from "@azure/msal-browser";

export const getAccessToken = async (caller: string, authClient: PublicClientApplication, silentRequest: Msal.SilentRequest): Promise<string | undefined> => {
    return await authClient
      .acquireTokenSilent(silentRequest)
      .then((result) => {
        if (result.accessToken) {
          return Promise.resolve(result.accessToken);
        }
        console.error("No access token retrieved");
        return "";
      })
      .catch(async (error) => {
        console.error(`[${caller}] Error acquireTokenSilent.`, error);
        if (error instanceof Msal.InteractionRequiredAuthError) {
          try {
            await authClient!.acquireTokenRedirect(silentRequest);
            return Promise.reject(new Error(`[${caller}] Redirecting for authentication`));
          } catch (redirectError) {
            console.error(`[${caller}] Error acquireTokenRedirect.`, redirectError);
            return Promise.reject(redirectError);
          }
        } else if (window.location.pathname !== "/login" || error.toString().includes("Token acquisition in iframe failed due to timeout")) {
          console.error(`Unexpected error during acquireTokenSilent ...`, error);
          const lastUserType = localStorage.getItem("lastUserType");
          const lastSelectedLangKey = localStorage.getItem("LastSelectedLangKey");
          localStorage.clear();
          if (lastUserType) {
            localStorage.setItem("lastUserType", lastUserType);
          }
          if (lastSelectedLangKey) {
            localStorage.setItem("LastSelectedLangKey", lastSelectedLangKey);
          }

          const savedDestination = sessionStorage.getItem("destination");
          sessionStorage.clear();
          if (savedDestination) {
            sessionStorage.setItem("destination", savedDestination);
          }
          await authClient!.acquireTokenRedirect(silentRequest);
          return Promise.reject(error);
        }
      });
}

export const getAccount = (authClient: PublicClientApplication | undefined): Msal.AccountInfo | undefined => {
    const activeAccount = authClient?.getActiveAccount();
    const allAccounts = authClient?.getAllAccounts();

    return activeAccount ?? (allAccounts?.length ?? 0) > 0 ? allAccounts![0] : undefined
}
